import { createSlice } from '@reduxjs/toolkit'

const navSlice = createSlice({
  name: 'nav',
  initialState: {
    sidebarShow: true,
    unfoldable: false,
  },
  reducers: {
    changeState: (state, action) => {
      state.sidebarShow =
        typeof action?.payload?.sidebarShow === 'undefined'
          ? state.sidebarShow
          : action?.payload?.sidebarShow
      state.unfoldable =
        typeof action?.payload?.unfoldable === 'undefined'
          ? state.unfoldable
          : action?.payload?.unfoldable
    },
  },
})

export const { changeState } = navSlice.actions
export default navSlice.reducer
